// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__34HTC","unreadBadge":"styles_unreadBadge__rHXoC","modalContent":"styles_modalContent__1iBkm","modal":"styles_modal__FQkaS"};